const InfoIcon = (props) => {
  return (
    <svg
      {...props}
      width="100%"
      height="100%"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00016 0.333313C3.32016 0.333313 0.333496 3.31998 0.333496 6.99998C0.333496 10.68 3.32016 13.6666 7.00016 13.6666C10.6802 13.6666 13.6668 10.68 13.6668 6.99998C13.6668 3.31998 10.6802 0.333313 7.00016 0.333313ZM7.66683 11.6666H6.3335V10.3333H7.66683V11.6666ZM9.04683 6.49998L8.44683 7.11331C7.96683 7.59998 7.66683 7.99998 7.66683 8.99998H6.3335V8.66665C6.3335 7.93331 6.6335 7.26665 7.1135 6.77998L7.94016 5.93998C8.18683 5.69998 8.3335 5.36665 8.3335 4.99998C8.3335 4.26665 7.7335 3.66665 7.00016 3.66665C6.26683 3.66665 5.66683 4.26665 5.66683 4.99998H4.3335C4.3335 3.52665 5.52683 2.33331 7.00016 2.33331C8.4735 2.33331 9.66683 3.52665 9.66683 4.99998C9.66683 5.58665 9.42683 6.11998 9.04683 6.49998Z"
        fill="#747985"
      />
    </svg>
  );
};

export default InfoIcon;
